import {ConnectedRouter} from 'connected-react-router';
import map from 'lodash/map';
import React from 'react';
import {Route, Switch} from 'react-router-dom';

import AppWrapper from './components/app-wrapper';

import {ROUTE_BASENAME, ROUTES} from './config';
import history from './history';

function createAppWrapper(staticProps) {
	return (dynamicProps) => <AppWrapper {...staticProps} {...dynamicProps} />;
}

export default (
	<ConnectedRouter basename={ROUTE_BASENAME} history={history}>
		<Switch>
			{map(ROUTES, ({path, props}) => (
				<Route
					key={path}
					path={path}
					render={createAppWrapper(props)}
				/>
			))}
		</Switch>
	</ConnectedRouter>
);
